import React, { useState, useEffect } from "react";
import { useLocation, useSearchParams, useNavigate } from "react-router-dom";
import "./AdminPanel.css";
import CrsMain from "../../components/ComponentsCrsSettings/CrsMain";
import SurveysMain from "../../components/ComponentsSurveys/SurveysMain";
import ReportsMain from "../../components/ComponentsReports/ReportsMain";
import IntegrationsMain from "../../components/ComponentsIntegration/IntegrationsMain";
import BusinessProfileMain from "../../components/ComponentsBusinessProfile/BusinessProfileMain";
import MyProfileMain from "../../components/ComponentsMyProfile/MyProfileMain";
import BillingMain from "../../components/ComponentsBilling/BillingMain";
import TeamMain from "../../components/ComponentsTeam/TeamMain";

const AdminPanel = () => {
  const [activePanel, setActivePanel] = useState('businessProfile');
  const [integrationStatus, setIntegrationStatus] = useState({
    slack: false,
    zoom: false,
  });
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Handle Slack and Zoom redirects and query parameters
  useEffect(() => {
    if (location.pathname.includes('/admin-panel/integrations/slack')) {
      const connected = searchParams.get('connected');
      if (connected === "1") {
        setIntegrationStatus((prev) => ({ ...prev, slack: true }));
        setActivePanel('integrations'); // Switch to integrations panel
        navigate('/admin-panel/integrations', { replace: true });
      }
    }
    
    // Handle Zoom redirect - check for workspaceId parameter which indicates Zoom OAuth return
    if (location.pathname === '/admin-panel' && searchParams.get('workspaceId')) {
      // Zoom has completed OAuth and redirected back
      setIntegrationStatus((prev) => ({ ...prev, zoom: true }));
      setActivePanel('integrations'); // Switch to integrations panel
      // Clean up the URL by removing the workspaceId parameter
      navigate('/admin-panel', { replace: true });
    }
  }, [location, searchParams, navigate]);

  const handleButtonClick = (panelName) => {
    setActivePanel(activePanel === panelName ? null : panelName);
  };

  return (
    <div className="admin-panel-wrapper">
      <div className="admin-panel-container">
        <h1>Admin Panel</h1>
        <div className="button-row top-row">
          <button
            className={`admin-button ${activePanel === 'businessProfile' ? 'active' : ''}`}
            onClick={() => handleButtonClick('businessProfile')}
          >
            Business Profile
          </button>

          <button
            className={`admin-button ${activePanel === 'myProfile' ? 'active' : ''}`}
            onClick={() => handleButtonClick('myProfile')}
          >
            My Profile
          </button>
          <button
            className={`admin-button ${activePanel === 'billing' ? 'active' : ''}`}
            onClick={() => handleButtonClick('billing')}
          >
            Billing
          </button>
          <button
            className={`admin-button ${activePanel === 'team' ? 'active' : ''}`}
            onClick={() => handleButtonClick('team')}
          >
            Team
          </button>
        </div>
        <div className="button-row bottom-row">
          <button
            className={`admin-button ${activePanel === 'integrations' ? 'active' : ''}`}
            onClick={() => handleButtonClick('integrations')}
          >
            Integrations
          </button>
          <button
            className={`admin-button ${activePanel === 'crs' ? 'active' : ''}`}
            onClick={() => handleButtonClick('crs')}
          >
            CRS Settings
          </button>
          <button
            className={`admin-button ${activePanel === 'surveys' ? 'active' : ''}`}
            onClick={() => handleButtonClick('surveys')}
          >
            Surveys
          </button>
          <button
            className={`admin-button ${activePanel === 'reports' ? 'active' : ''}`}
            onClick={() => handleButtonClick('reports')}
          >
            Reports
          </button>
        </div>
      </div>
      {activePanel === 'businessProfile' && (
        <div className="settings-main-outer-container">
          <BusinessProfileMain />
        </div>
      )}

      {activePanel === 'myProfile' && (
        <div className="settings-main-outer-container">
          <MyProfileMain />
        </div>
      )}

      {activePanel === 'billing' && (
        <div className="settings-main-outer-container">
          <BillingMain />
        </div>
      )}

      {activePanel === 'team' && (
        <div className="settings-main-outer-container">
          <TeamMain />
        </div>
      )}

      {activePanel === 'crs' && (
        <div className="settings-main-outer-container">
          <CrsMain />
        </div>
      )}

      {activePanel === 'surveys' && (
        <div className="settings-main-outer-container">
          <SurveysMain />
        </div>
      )}

      {activePanel === 'reports' && (
        <div className="settings-main-outer-container">
          <ReportsMain />
        </div>
      )}

      {activePanel === 'integrations' && (
        <div className="settings-main-outer-container">
          <IntegrationsMain integrationStatus={integrationStatus} />
        </div>
      )}
    </div>
  );
};

export default AdminPanel;